import React from 'react';
import { useTranslation } from 'react-i18next';
import './ComingSoon.css';

const PublicationBooks = () => {
  const { t } = useTranslation();

  return (
    <div className="coming-soon-container">
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <div className="text-center mb-5">
              <h1 className="display-4 fw-bold mb-3 coming-soon-title">
                <i className="fas fa-building me-3"></i>
                {t('publicationsDropdown.books')}
              </h1>
              <p className="lead coming-soon-subtitle">
                {t('publicationsDropdown.books')}
              </p>
            </div>

            {/* Coming Soon Content */}
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="coming-soon-card">
                  <div className="coming-soon-card-body">
                    <div className="mb-4">
                      <i className="fas fa-clock coming-soon-icon"></i>
                    </div>
                    <h2 className="coming-soon-card-title mb-3">
                      {t('comingSoon.title')}
                    </h2>
                    <p className="coming-soon-description mb-4">
                      {t('comingSoon.booksDescription')}
                    </p>
                    <div className="d-flex justify-content-center">
                      <div className="coming-soon-spinner" role="status">
                        <span className="visually-hidden">{t('comingSoon.loading')}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicationBooks;
